export default __webpack_public_path__ + "static/media/vanguard_logo_256.53dae4f1.png";